import styled, { css, RuleSet } from 'styled-components'

import { BorderLoader } from '@/components/ui/loaders/border-loader'
import { Typography } from '@/components/ui/typography'
import { MarketShopOrderStatus } from '@/models'

export const Content = styled.div(
  ({ theme }) => css`
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: ${theme.space['16']};
  `,
)

export const Controls = styled.div(
  ({ theme }) => css`
    position: sticky;
    bottom: 0;
    display: grid;
    grid-template-columns: 1fr;
    gap: ${theme.space['8']};
    margin-top: auto;
    padding: ${theme.space['16']};
    background-color: ${theme.colors.white};
    box-shadow: ${theme.shadow.marketShopShadow};
  `,
)

export const OrderContainer = styled.button(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${theme.space['8']};
    padding: ${theme.space['16']} ${theme.space['0']}
      calc(${theme.space['16']} - ${theme.border.size['1']});
    border-bottom: ${theme.border.size['1']} solid ${theme.colors.gray300};
    cursor: pointer;

    &:focus-visible {
      outline: -webkit-focus-ring-color auto ${theme.border.size['1']};
    }
  `,
)

export const BadgeText = styled(Typography)<{ $status: MarketShopOrderStatus }>(
  ({ theme, $status }) => {
    const baseStyles = css`
    padding: ${theme.space['4']} ${theme.space['16']};
    border-radius: ${theme.border.radius['full']};
  `

    const statusStyles: Record<MarketShopOrderStatus, RuleSet> = {
      awaiting_pickup: css`
      background-color: ${theme.colors.green100};
      color: ${theme.colors.green500};
    `,
      completed: css`
      background-color: ${theme.colors.gray200};
      color: ${theme.colors.black500};
    `,
      declined: css`
      background-color: ${theme.colors.red100};
      color: ${theme.colors.red500};
    `,
      in_progress: css`
      background-color: ${theme.colors.blue100};
      color: ${theme.colors.blue500};
    `,
      new: css`
      background-color: ${theme.colors.orange100};
      color: ${theme.colors.orange500};
    `,
    }

    return css`
    ${baseStyles}
    ${statusStyles[$status]}
  `
  },
)

export const Loader = styled(BorderLoader)<{ $hasContent: boolean }>(
  ({ theme, $hasContent }) => css`
    flex-shrink: 0;
    margin: ${$hasContent ? theme.space['100'] : 'auto'} auto;
  `,
)
